/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable camelcase */
/* eslint-disable react/jsx-indent */
/* eslint-disable no-else-return */
/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
/* eslint-disable no-bitwise */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable valid-typeof */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
/* eslint-disable no-use-before-define */
/* eslint-disable import/no-unresolved */
import {
  useState, useEffect, useContext, useCallback, memo,
} from 'react';
import { useParams, useHistory } from 'react-router-dom';

// Router last location
import { useLastLocation } from 'react-router-last-location';

// material ui libraries and components
import {
  Grid,
  useMediaQuery,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useTheme } from '@material-ui/core/styles';
// third party packages and libraries
import Swal from 'sweetalert2';
// analytics libraries
import ReactGA from 'react-ga';
// context
import { UserContext } from '@context/UserContext';
// internal features
import { GiftsMenu, GiftsValuesDropDown } from '@features/StreamGifts';
import VideoStream from '@features/VideoStreams';
import ChatStream from '@features/ChatStreams';
import ProfileAbout from '@features/UserProfile/components/ProfileAbout/ProfileAbout';
import ShortVideoList from '@features/UserProfile/components/ShortVideoList/ShortVideoList';
import ProfileHeader from '@features/UserProfile/components/ProfileHeader/ProfileHeader';
import LoginModalComponent from '@features/Authentication';
// ban and lock
import LockUser from '@features/UserAccountLock';
import BanUser from '@features/UserAccountBan';
// shared components
import { giftPresent } from '@shared/services/sharedGiftsApi';
import { UserNotFound } from '@shared/components';
// api for profile page
import {
  getUser, getLivestream, getUserKlips,
} from '@shared/services/userApi';
// utilities
import NumberWithCommas from '@shared/utils/NumberWithCommas';
import makeUniqueId from 'shared/utils/IdGenerator';
// data config
import { profileThemeConfig } from '@features/UserProfile/data/profileTheme';
// styles
import './Profile.css';

const useStyles = profileThemeConfig();

function Profile() {
  // States
  const theme = useTheme();
  const history = useHistory();
  const { username } = useParams();
  // import the custom styles from useStyles
  const classes = useStyles();

  const { loggedIn } = useContext(UserContext); // profile data - store
  const isExtraSmall = useMediaQuery(theme.breakpoints.down('xs'));
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const [user, setUser] = useState([]);
  const [guid, setGuid] = useState('');
  const [userFound, setUserFound] = useState('');

  const [liveData, setLiveData] = useState([]); // User Livestream Data
  const [pageSize] = useState(8);

  const [channelIdVal, setChannelIdVal] = useState('');
  const [isLiveVal, setIsLiveVal] = useState(0);
  const [streamTitle, setStreamTitle] = useState('');

  // ban and lock feat
  const [userBanDetails, setUserBanDetails] = useState([]);
  const [updatedLoggedIn, setUpdatedLoggedIn] = useState([]);
  const [banModalStatus, setBanModalStatus] = useState(false);

  const [isCampaignPage, setIsCampaignPage] = useState(false);
  const [offlineCampaignStream, setOfflineCampaignStream] = useState(false);

  // shortvideo states
  const [isShortVideoLoading, setIsShortVideoLoading] = useState(false);
  const [shortVideosList, setShortVideosList] = useState([]);
  const [isUserPrivate, setIsUserPrivate] = useState(false);
  const [shortVideosPrivacy, setShortVideosPrivacy] = useState('');
  const [hasMoreVideos, setHasMoreVideos] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  // message response for privacy settings
  const onlyFriendsMessage = 'Only friends can see';
  const mySelfOnlyMessage = 'Timeline is not public';

  let hostUrl = '/';
  if (process.env.REACT_APP_ENABLE_KL1 === 'true') {
    hostUrl = process.env.REACT_APP_KL1_BASE_URL;
  }
  const usernameLink = hostUrl + user.username;

  // navigate to short video page once user clicks card
  const navigateToShortVideoPage = (feed_id) => {
    history.push(`/${user.username}/klips/${feed_id}`);
  };

  // google analytics, initialize tracking using Google Analytics
  useEffect(() => {
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview(window.location.pathname);
  }, []);
  // Segment user location tracker
  const lastLocation = useLastLocation();
  const segmentHost = (isLive, channelId, userId) => {
    const segmentValHost = (isLive === 1);
    function navigationType() {
      let result = '';
      let p;
      if (window.performance.getEntriesByType('navigation')) {
        p = window.performance.getEntriesByType('navigation')[0].type;
        if (p === 'navigate') { result = document.referrer; }
        if (p === 'reload') { result = ''; }
        if (p === 'back_forward') { result = document.referrer; }
      }
      return result;
    }
    function sourceTracker() {
      if (lastLocation) {
        return window.location.origin + lastLocation.pathname;
      } else if (document.referrer !== '') {
        return navigationType();
      }
      return 'Others';
    }
    window.analytics.track('User Profile Viewed', {
      feed_id: channelId,
      host: segmentValHost,
      profile_user_id: userId,
      source: sourceTracker(),
    });
  };
  // instant modal for blocked user
  const blockUser = () => {
    setIsLiveVal(0);
    setLiveData('');
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'This user has blocked you.',
    });
  };
  // instant modal for livestream ended
  const endStream = () => {
    setIsLiveVal(0);
    setLiveData('');
    Swal.fire({
      icon: 'info',
      text: 'Livestream has ended',
    });
  };

  // login modal states and status
  const [openModal, setOpenModal] = useState(false);
  const getLoggedInAction = useCallback((data) => {
    setOpenModal(data.modalStatus);
  }, []);
  const modalActions = useCallback((data) => {
    setOpenModal(data.modalStatus);
  }, []);

  // --------------- ALL LIVESTREAM API REQUEST AND CHECKER ---->
  // get livestream data
  const LivestreamAPI = (channelId) => {
    getLivestream(channelId)
      .then((res) => {
        if (res.data.code === '200'
        && res.data.status === 'success') {
          setStreamTitle(res.data.data.title);
          setLiveData(res.data.data);
        } else if (res.data.status === 'error' && res.data.data.message && res.data.data.message === 'This user has blocked you.') {
          blockUser();
        }
      });
  };

  const callLivestreamApi = (
    channelId,
    isLive,
    isCampaignPageStatus,
    isOfflineCampaignStream,
  ) => {
    if (process.env.REACT_APP_VIEW_PROFILE_STREAM === 'true') {
      if (channelId) {
        if (isLive === 1 || isOfflineCampaignStream) {
          setIsLiveVal(isLive);
        }
        if (isLive === 2 && isCampaignPageStatus === false) {
          return null;
        }
        LivestreamAPI(channelId);
      }
    }
  };

  const checkIfCampaignPage = (
    userName,
    campaignId,
    isLiveStatus,
    channelIdHandler,
  ) => {
    const campaignPage = `/${userName}/campaign`;
    let isCampaignPageStatus = false;
    let isOfflineCampaignStream = false;
    if (campaignPage === window.location.pathname) {
      isCampaignPageStatus = true;
      setIsCampaignPage(true);
      if (campaignId === '') {
        // <Redirect to={`/${userName}/about`} />
        window.history.replaceState(null, '', `/${userName}/about`);
        window.location.reload();
        isCampaignPageStatus = false;
        setIsCampaignPage(false);
      } else if (campaignId && isLiveStatus === 2 && channelIdHandler) {
        setOfflineCampaignStream(true);
        isOfflineCampaignStream = true;
      }
    } else if (campaignId && isLiveStatus === 2 && channelIdHandler) {
      isOfflineCampaignStream = true;
    }

    callLivestreamApi(
      channelIdHandler,
      isLiveStatus,
      isCampaignPageStatus,
      isOfflineCampaignStream,
    );
  };
  // get user profile info upon initial load
  useEffect(() => {
    getUser(username)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.code === '200' && response.data.status === 'success') {
            setUser(response.data.data);
            setGuid(response.data.data.guid);
            setUserFound(true);
            setChannelIdVal(response.data.data.channel_id);

            if (process.env.REACT_APP_ON_SEGMENT === 'true') {
              segmentHost(
                response.data.data.isLive,
                response.data.data.channel_id,
                response.data.data.user_id,
              );
            }
            // function for getting the livestream and checking if campaign stream
            checkIfCampaignPage(
              response.data.data.username,
              response.data.data.campaign_id,
              response.data.data.isLive,
              response.data.data.channel_id,
            );
          }
        } else {
          setUserFound(false);
        } // End if
      })
      .catch((error) => {
        console.error(error);
      });
  }, [username]);

  // ---------- ALL API CALL AND CHECKER FOR SHORT VIDEOS ------->
  // checker of privacy settings
  const privacyChecker = (response) => {
    if (response.data.code === '200') {
      if (response.data.data.hasOwnProperty('1')) {
        setIsUserPrivate(true);
        if (response.data.data['1'] === onlyFriendsMessage) {
          setShortVideosPrivacy(`The privacy settings of this profile are private. You and ${user.nickname} must follow each other to see this feed.`);
        } else if (response.data.data['1'] === mySelfOnlyMessage) {
          setShortVideosPrivacy('The privacy settings of this profile are private. Their posts have been hidden.');
        }
        setShortVideosList([]);
      } else {
        setIsUserPrivate(false);
        setShortVideosList([...shortVideosList, ...response.data.data.list]);
      }
    }
  };

  // pagination checker for infinite scroll
  const pageChecker = (response) => {
    if (response.data.code === '200'
    && response.data.status === 'success') {
      if (currentPage < response.data.data.total_pages) {
        setCurrentPage(currentPage + 1);
        setHasMoreVideos(true);
      } else if (currentPage >= response.data.data.total_pages) {
        setHasMoreVideos(false);
      }
    } else if (response.data.code === '500' && response.data.status === 'error') {
      setCurrentPage(0);
      setHasMoreVideos(false);
    }
  };
  // fetch more short videos
  const fetchMore = () => {
    if (guid !== '' && guid !== typeof undefined) {
      setTimeout(() => {
        getUserKlips(guid, currentPage, pageSize)
          .then((response) => {
            if (response.status === 200) {
              pageChecker(response);
              privacyChecker(response);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }, 1000);
    }
  };
  // API Request Side Effect for getting user short videos upon initial load
  useEffect(() => {
    let componentMounted = true;
    if (guid !== '' && guid !== typeof undefined) {
      setIsShortVideoLoading(true);
      getUserKlips(guid, currentPage, pageSize)
        .then((response) => {
          if (response.status === 200) {
            if (componentMounted) {
              pageChecker(response);
              privacyChecker(response);
              setIsShortVideoLoading(false);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
    return (() => {
      if (componentMounted) {
        componentMounted = false;
      }
    });
  }, [guid]);

  // --------------- ALL FUNCTIONS FOR STREAM GIFTS ----->
  // user coins and gift local variables
  let giftId = '';
  let giftCategory = 1;
  let repeat = 1;
  let userCoin = '0';
  // state for sending gifts modal --> initialize as hidden
  const [sendVgModalStatus, setSendVgModalStatus] = useState(false);

  // check the value of coins if user is authenticated
  if (loggedIn.length !== 0) {
    userCoin = loggedIn.coin;
  }
  // select vg
  const selectVg = (gift, category) => {
    giftId = gift;
    giftCategory = category;
  };
  // handler for sending multiple gifts at once
  const handleRepeat = (repeatVal) => {
    repeat = repeatVal;
  };
  // check banned accounts commenting
  const checkBanStatus = async (userData) => {
    if (userData.user_status === 'ban' || userData.user_status === 'lock') {
      setBanModalStatus(true);
    } else if (userData.user_status === 'normal') {
      setSendVgModalStatus(true);
    }
  };
  // open the vg selection modal
  const openVgSelection = async () => {
    if (loggedIn.length !== 0) {
      await getUser(loggedIn.username)
        .then(async (userRes) => {
          if (userRes.data.code === '200') {
            setUpdatedLoggedIn(userRes.data.data);
            setUserBanDetails(userRes.data.data.banDetails);
            await checkBanStatus(userRes.data.data);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      return (setOpenModal(true));
    }
  };
  // hide vg modal
  const closeSendVgModal = () => {
    setSendVgModalStatus(false);
  };
  // check if user is lock or ban
  const renderBanOrLockModal = () => {
    if (updatedLoggedIn.user_status === 'ban') {
      return (<BanUser banModalStatus={banModalStatus} userBanDetails={userBanDetails} />);
    } else if (updatedLoggedIn.user_status === 'lock') {
      return (<LockUser banModalStatus={banModalStatus} />);
    }
  };

  const sendVgApi = (sendGiftParams) => {
    giftPresent(sendGiftParams)
      .then(((response) => {
        if (response.data.status === 'success') {
          if (response.data.code === '200') {
            // update user coin
            document.getElementById('coin-text').innerHTML = ` ${NumberWithCommas(response.data.data.coin)}`;
          } else if (response.data.code === 401) {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: response.data.data.message.toString(),
            });
          }
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: response.data.data.message.toString(),
          });
        }
      }))
      .catch((error) => {
        console.error(error);
      });
  };
  const sendVg = async () => {
    if (giftId && repeat && giftCategory) {
      const category = giftCategory;
      const gift_trace_id = makeUniqueId(32);

      const sendGiftParams = new URLSearchParams({
        category,
        gift_id: giftId,
        gift_trace_id,
        channel_id: liveData.channel_id,
        host_id: liveData.liveuser.guid,
        repeat,
      }); // gift present

      await getUser(loggedIn.username)
        .then(async (res) => {
          if (res.data.code === '200') {
            const updatedUser = res.data.data;
            if (updatedUser.user_status === 'ban' || updatedUser.user_status === 'lock') {
              setUpdatedLoggedIn(updatedUser);
              setUserBanDetails(updatedUser.banDetails);
              setBanModalStatus(true);
            } else if (updatedUser.user_status === 'normal') {
              sendVgApi(sendGiftParams);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };
  // ------- PROFILE CONTAINER STYLES ---- >
  const profileBodyMarginTop = () => {
    if (isLiveVal === 1 || offlineCampaignStream) {
      if (isMobile) return '0vh';
      return '0vh';
    }
    return '1px';
  };

  const profileBodyMarginBottom = () => {
    if (isCampaignPage) {
      if (isMobile) return '0px';
      return '3vh';
    }
    return '0px';
  };
  const renderWidthContainer = () => {
    if (isMobile || isTablet) return '100%';
    return '45vw';
  };

  // check if user is live
  const checkIfLive = () => {
    if (user.isLive) return streamTitle;
    return '';
  };
  function ProfileContainer() {
    return (
      <div className='profile-body' style={{ marginTop: profileBodyMarginTop(), marginBottom: profileBodyMarginBottom(), width: '100%' }}>
        <ProfileHeader
          isMobile={isMobile}
          isTablet={isTablet}
          isExtraSmall={isExtraSmall}
          isLive={user.isLive}
          userNameLink={usernameLink}
          avatarImage={user.avatar}
          nickName={user.nickname}
          streamTitle={checkIfLive()}
          userName={user.username}
          userInfo={user}
          channelId={channelIdVal}
        />
        <Grid
          item
          style={{
            paddingRight: 15, paddingLeft: 15, width: renderWidthContainer(), marginTop: 20,
          }}
          lg={12}
          md={12}
        >
          <ProfileAbout
            intro={user.intro}
            isMobile={isMobile}
            isTablet={isTablet}
            nickname={user.nickname}
          />
          <ShortVideoList
            isShortVideoLoading={isShortVideoLoading}
            shortVideosList={shortVideosList}
            fetchMoreShortVideos={fetchMore}
            hasMoreVideos={hasMoreVideos}
            navigateToShortVideoPage={navigateToShortVideoPage}
            isUserPrivate={isUserPrivate}
            shortVideosPrivacy={shortVideosPrivacy}
            userNickName={user.nickname}
          />
        </Grid>
      </div>
    );
  }
  const componentVideoStream = () => (
    <Grid container>
      <>
        <Grid item lg={9} md={8} sm={12} xs={12}>
          <VideoStream
            channelId={channelIdVal}
            video={liveData.video}
            type={user.type}
            relation_status={user.relation_status}
            endStream={endStream}
            offlineCampaignStream={offlineCampaignStream}
            isCampaignPage={isCampaignPage}
          />
        </Grid>
        <Grid item lg={3} md={4} sm={12} xs={12}>
          {sendVgModalStatus
            && (
              <div className={classes.paper}>
                <CloseIcon
                  fontSize='small'
                  className='close-gift-icon'
                  disableRipple
                  onClick={closeSendVgModal}
                />
                <GiftsMenu
                  data={liveData}
                  userData={loggedIn}
                  selectVg={selectVg}
                />
                <Grid
                  item
                  container
                  justifyContent='right'
                >
                  <GiftsValuesDropDown
                    handleRepeat={handleRepeat}
                    sendVg={sendVg}
                    repeat={repeat}
                  />
                </Grid>
              </div>
            )}
          <ChatStream
            rtmId={liveData.rtm_user_id}
            channelId={liveData.channel_id}
            userLoggedIn={loggedIn}
            rtmToken={liveData.rtm_token}
            videoSlots={liveData.video}
            video={liveData.video}
            openVgSelection={openVgSelection}
            userCoin={userCoin}
            campaignId={liveData.campaign_id}
            rtmp={liveData.rtmp}
            blockUser={blockUser}
            landscape={liveData.landscape}
            hideStreamDiamond={liveData.hide_stream_diamond}
          />
        </Grid>
      </>
      <Grid item lg={9} md={8} sm={12} xs={12}>
        <ProfileContainer />
      </Grid>
    </Grid>
  );
  return (
    <>
      {openModal && (
        <LoginModalComponent
          isOpenModal={openModal}
          modalFunc={modalActions}
          loggedInFunc={getLoggedInAction}
        />
      )}
      {userFound && (
        <div className='profile-container'>
          {isLiveVal !== 1 && liveData.length === 0 && <ProfileContainer />}
          {liveData.length !== 0 && componentVideoStream() }
        </div>
      )}
      { !userFound && <UserNotFound userFound={userFound} />}
      { banModalStatus && renderBanOrLockModal() }
    </>
  );
}

export default memo(Profile);
